import script from "./DisplayChatName.vue?vue&type=script&lang=ts&setup=true"
export * from "./DisplayChatName.vue?vue&type=script&lang=ts&setup=true"

import "./DisplayChatName.vue?vue&type=style&index=0&id=4b60ac40&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b60ac40"]])

export default __exports__